import { Tabs } from 'antd';
import './VtxTabs.scss';
import * as React from 'react';
import { TabsProps, TabPaneProps } from 'antd/lib/tabs';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';

export interface VtxTabsProps extends TabsProps, IAutomatable {}
export interface VtxTabPaneProps extends TabPaneProps, IAutomatable {}

export const VtxTabs: FunctionComponent<VtxTabsProps> = React.memo((props: VtxTabsProps) => {
    const automationClass = 'vtx-tabs';
    const { className, children, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);

    return (
        <Tabs className={classNamesCombined} data-automation-class={automationClass} {...otherProps}>
            {props.children}
        </Tabs>
    );
});

/**
 * Currently ant does not render 'vtx-tab-pane' automation class inside VtxTabs.
 * Please use vtx-tabs for automation class.
 */
export const VtxTabPane: FunctionComponent<VtxTabPaneProps> = React.memo((props: VtxTabPaneProps) => {
    const automationClass = 'vtx-tab-pane';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);

    return (
        <Tabs.TabPane className={classNamesCombined} {...otherProps}>
            {props.children}
        </Tabs.TabPane>
    );
});
